import React, { ReactNode } from 'react';
import { ContentPreloader } from './ContentPreloader';
import { ContentPreloaderCompact } from './ContentPreloaderCompact';

interface QuirkLoaderProps {
	loadingMessage?: string;
	isLoading: boolean;
	compact?: boolean;
	data: any;
	noResults: JSX.Element;
	children: ReactNode;
}

export const QuirkLoader = ({ loadingMessage, isLoading, data, noResults, children, compact }: QuirkLoaderProps) => {
	const isEmpty = Array.isArray(data) ? data.length === 0 : data === null || data === undefined;

	return isLoading ? (
		compact ? (
			<ContentPreloaderCompact message={loadingMessage || 'Loading...'} />
		) : (
			<ContentPreloader message={loadingMessage || 'Loading...'} />
		)
	) : isEmpty ? (
		<>{noResults}</>
	) : (
		<>{children}</>
	);
};
